module.exports = __webpack_public_path__ + "img/caselist31.602c4701.jpg";